import styled from "styled-components";
import lightLeak from "./assets/light-leak.jpg";

export const Banner = styled.section`
  position: relative;
  isolation: isolate;
  height: 280px;
  overflow: hidden;
  border-radius: 12px;
  background: #000;
  box-shadow: inset 0 0 0 1px #15151b;
  margin-bottom: 12px;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.85) 0%,
      rgba(0, 0, 0, 0.5) 40%,
      transparent 65%
    );
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    left: -25%;
    bottom: -25%;
    width: 720px;
    height: 720px;
    z-index: 3;
    opacity: 0.12;
    background: radial-gradient(closest-side, #8856ff 0%, transparent 72%);
    pointer-events: none;
  }

  @media (min-width: 2200px) {
    height: 420px;
  }

  @media (max-width: 760px) {
    height: 200px;
  }
`;

export const BannerArtwork = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  height: 115%;
  width: auto;
  max-width: none;
  mix-blend-mode: screen;
  pointer-events: none;
  -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 40%),
    linear-gradient(0deg, transparent 0%, #000 25%);
  -webkit-mask-composite: source-in;
  mask-image: linear-gradient(90deg, transparent 0%, #000 40%),
    linear-gradient(0deg, transparent 0%, #000 25%);
  mask-composite: intersect;

  @media (max-width: 1100px) {
    height: 100%;
  }
`;

export const BannerLightLeak = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  background: url(${lightLeak}) center / cover no-repeat;
  mix-blend-mode: screen;
  opacity: 0.22;
  pointer-events: none;
`;

export const BannerTitle = styled.h1`
  position: absolute;
  z-index: 4;
  left: 28px;
  bottom: 24px;
  max-width: calc(100% - 56px);
  margin: 0;
  color: #fff;
  font-family: AffiliateDashboardFont, sans-serif;
  font-size: 64px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: -2px;

  @media (min-width: 2200px) {
    font-size: 96px;
  }

  @media (max-width: 760px) {
    left: 20px;
    bottom: 20px;
    max-width: calc(100% - 40px);
    font-size: 34px;
    letter-spacing: -1px;
  }
`;

export const BannerHash = styled.div`
  position: absolute;
  z-index: 4;
  right: 24px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  color: #b9a8ff;
  font-family: AffiliateDashboardMono, monospace;
  font-size: 9px;
  line-height: 1.1;
  letter-spacing: 1px;
  opacity: 0.55;
  pointer-events: none;

  @media (max-width: 760px) {
    display: none;
  }
`;

export const BannerParticles = styled.canvas`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  mix-blend-mode: screen;
`;
